import { useState } from 'react'

export function useGclid() {
  const [gclid] = useState(() =>
    new URLSearchParams(window.location.search).get('gclid'),
  )
  return gclid
}
